function updateForestForImpls(f, impls) {
    const names = new Map(f.map((it, idx) => [it.name, idx]));
    return Object.keys(impls)
        .reduce((f, name) => {
            if (!names.has(name)) {
                const impl = {
                    name,
                    implementer: impls[name],
                    kids: [],
                };
                names.set(name, f.length);
                return f.concat(impl);
            }
            if (f[names.get(name)].implementer === impls[name]) {
                return f;
            }
            f = f.slice();
            const impl = f[names.get(name)];
            impl.implementer = impls[name];
            impl.kids = [];
            return f;
        }, f)
        .sort((a, b) => a.name < b.name ? -1 : 1);
}

export default updateForestForImpls;



// WEBPACK FOOTER //
// ./app/lib/reauth/updateForestForImpls.js